import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, TextField, Typography } from "@mui/material";
import { Alert, AlertTitle, Button } from "@mui/material";
import TaskAltRoundedIcon from "@mui/icons-material/TaskAltRounded";
import { useAuthProvider } from "../../context/AuthProvider";
import { useRouter } from "next/router";
import { onGetStripeLogin, onGetStripeOtp } from "../../src/utils/queries";
import toast from "react-hot-toast";

const StripeModal = ({ show, setShow }) => {
  const [link, setLink] = React.useState("");
  const [textBox, setTextBox] = React.useState("");
  const [otp, setOtp] = React.useState("");

  const { user } = useAuthProvider();

  const isNotAdmin = user && user?.role?.id < 2 && show ? true : false;

  const {
    isSuccess,
    isError,
    data,
    error: stripeError,
    isLoading,
  } = onGetStripeOtp(isNotAdmin, otp);

  const handleClose = () => {
    setShow(false);
    setOtp("");
    setTextBox("");
  };

  React.useEffect(() => {
    if (isSuccess) {
      const stripeLink = data.data.data?.strpe_login_link_url;
      if (stripeLink) {
        handleClose();

        toast.success("Stripe link generated, you will be redirected shortly");

        setTimeout(() => {
          window.open(
            stripeLink,
            "_blank",
            "noopener,noreferrer"
          );
        }, 3000);
      }
    }

    //   setLink(data.data.data?.strpe_login_link_url );
    if (isError) {
      console.log(stripeError?.response?.data);
    }
  }, [isSuccess, isError, data]);

  const router = useRouter();

  if (!user?.has_sole_superuser) {
    return (
      <Dialog
        open={show}
        fullWidth
        maxWidth={"xs"}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          // minHeight:'10rem',
          zIndex: "10005",
          "& .MuiDialog-paper": {
            px: "1.2em",
            py: "1em",
            borderRadius: "8px",
          },
        }}
      >
        <DialogTitle
          // id="alert-dialog-title"
          sx={{
            fontSize: "18px",
            fontWeight: 500,
            color: "grey.dark",
            justifyContent: "space-between",
            display: "flex",
            "& svg": {
              padding: "0",
            },
          }}
        >
          <Typography
            variant="h4"
            component={"h4"}
            fontWeight={500}
            lineHeight={"24px"}
            display="flex"
            justifyContent={"center"}
            alignItems={"center"}
          >
            Stripe login
          </Typography>
          <IconButton
            aria-label="close"
            size="large"
            sx={{ fontSize: "1.4rem" }}
            onClick={handleClose}
          >
            <ClearRoundedIcon fontSize="inherit" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {stripeError?.response?.data?.message ==
            "You need to create another super user to access Stripe." ? (
            <>
              <Alert
                severity="warning"
                color={"grey"}
                sx={{
                  marginBlock: "1em",
                  borderRadius: "8px",
                  fontSize: "14px",
                  border: "1px solid #FFEECC",
                  background: "#FFFAF0",
                  color: "#425A70",
                  "& .MuiAlert-icon": {
                    color: "#B37800",
                  },
                }}
              >
                <Typography
                  variant="big"
                  fontWeight={500}
                  mb={"0.5em"}
                  color={"#B37800"}
                  component={"p"}
                >
                  Second super user required
                </Typography>
                Please create a second super user to enable stripe access.
              </Alert>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  mt: "1.5em",
                }}
              >
                <Button
                  onClick={() => {
                    handleClose();
                    router.push('/settings?key=users')
                  }}
                  sx={{
                    borderRadius: "8px",
                    paddingY: "8px",
                    paddingX: "12px",
                    fontSize: "14px",
                    fontWeight: "600",
                    textTransform: "none",
                    "&.Mui-disabled": {
                      opacity: "0.3",
                      backgroundColor: "primary.main",
                      color: "white",
                    },
                  }}
                  variant="contained"
                  // color="error"
                  disableElevation
                  disableFocusRipple
                  disableRipple
                >
                  Create Super user
                </Button>
              </Box>
            </>
          ) : (
            <>
              <Alert
                icon={<TaskAltRoundedIcon sx={{ color: "success.main" }} />}
                severity={"success"}
                color={"success"}
                sx={{
                  borderRadius: "8px",
                  fontSize: "12px",
                  marginBottom: "0.2em",
                  // background: "#FFF5F5",
                  border: "1px solid",
                  borderColor: "success.main",
                }}
              >
                <AlertTitle sx={{ color: "success.main", fontSize: "14px" }}>
                  OTP sent
                </AlertTitle>
                Please note that an OTP has been sent to the other super user,
                please input the correct OTP to access your stripe account
              </Alert>
              <TextField
                value={textBox}
                onChange={(e) => setTextBox(e.target.value)}
                placeholder="OTP"
                error={isError}
                helperText={
                  isError && (
                    <Typography variant="small" color={"red"}>
                      OTP is incorrect, please try again
                    </Typography>
                  )
                }
                sx={{
                  border: "none",
                  borderColor: "",
                  fontSize: "14px",
                  mt: "2em",
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "grey.border40",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "primary.main",
                    },
                  },
                }}
                size="small"
                fullWidth
              />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  mt: "1.5em",
                }}
              >
                <Button
                  disabled={!textBox || isLoading}
                  onClick={() => {
                    setOtp(textBox);
                  }}
                  sx={{
                    borderRadius: "8px",
                    paddingY: "8px",
                    paddingX: "12px",
                    fontSize: "14px",
                    fontWeight: "600",
                    textTransform: "none",
                    "&.Mui-disabled": {
                      opacity: "0.3",
                      backgroundColor: "primary.main",
                      color: "white",
                    },
                  }}
                  variant="contained"
                  // color="error"
                  disableElevation
                  disableFocusRipple
                  disableRipple
                >
                  Go to stripe
                </Button>
              </Box>
            </>
          )}
        </DialogContent>
      </Dialog>
    );
  }

  return <></>;
};

export default StripeModal;
